'use client'

import { useEffect } from 'react'

function clearAllCookies() {
  try {
    const hostname = window.location.hostname
    const domains = [hostname, `.${hostname}`]
    const paths = ['/', '']
    // Parse document.cookie and attempt to delete each
    document.cookie.split(';').forEach(raw => {
      const eqPos = raw.indexOf('=')
      const name = (eqPos > -1 ? raw.substr(0, eqPos) : raw).trim()
      if (!name) return
      domains.forEach(domain => {
        paths.forEach(path => {
          document.cookie = `${name}=; Max-Age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}; domain=${domain}`
          document.cookie = `${name}=; Max-Age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}`
          // Try samesite variants to ensure removal across prior settings
          document.cookie = `${name}=; Max-Age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}; domain=${domain}; SameSite=Lax`
          document.cookie = `${name}=; Max-Age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}; domain=${domain}; SameSite=Strict`
          document.cookie = `${name}=; Max-Age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}; domain=${domain}; SameSite=None; Secure`
        })
      })
    })
    // Explicitly target known auth cookies
    const known = ['preauth', 'csrftoken', 'sessionid', 'access', 'refresh', 'auth-token', 'temp-token']
    known.forEach(name => {
      domains.forEach(domain => {
        paths.forEach(path => {
          document.cookie = `${name}=; Max-Age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}; domain=${domain}`
          document.cookie = `${name}=; Max-Age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}`
          document.cookie = `${name}=; Max-Age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}; domain=${domain}; SameSite=None; Secure`
        })
      })
    })
  } catch {}
}

function clearStorage() {
  try {
    // Targeted removals
    const keys = [
      'login2fa:preauth',
      'login2fa:phase',
      'login2fa:email',
      'auth.token',
      'auth.refresh',
      'auth.email',
      'user',
      'userProfile',
      'authState',
      'permissions',
      'lastActivity',
    ]
    keys.forEach(k => { try { localStorage.removeItem(k) } catch {} })
    keys.forEach(k => { try { sessionStorage.removeItem(k) } catch {} })
    // Wildcard-like cleanup for common prefixes
    try {
      Object.keys(localStorage).forEach(k => { if (/^(auth\.|token_|login2fa:)/.test(k)) localStorage.removeItem(k) })
    } catch {}
    try {
      Object.keys(sessionStorage).forEach(k => { if (/^(auth\.|token_|login2fa:)/.test(k)) sessionStorage.removeItem(k) })
    } catch {}
  } catch {}
}

export default function ResetAuthOnMount() {
  useEffect(() => {
    // Clear client auth artifacts as soon as we hit /login
    clearStorage()
    clearAllCookies()
  }, [])
  return null
}
